import React from "react";
import { Link, useLocation } from "react-router-dom";
import REVIEWER_1 from "../assets/reviews/Review female image.png";
import REVIEWER_2 from "../assets/reviews/Review male image.png";


const goldGradient = {
  background: "linear-gradient(135deg, #C89B2B 0%, #F2D36A 100%)",
};

const branchLocation = {
  title: "G1 Gold - Malleshwaram Branch",
  directions:
    "https://www.google.com/maps/search/?api=1&query=G1%20Gold%20Malleshwaram%20Bengaluru",
  mapEmbed:
    "https://www.google.com/maps?q=G1%20Gold%20Malleshwaram%20Bengaluru&output=embed",
};

const testimonials = [
  {
    name: "Akash",
    location: "Bangalore",
    initial: "S",
    image: REVIEWER_2,
    rating: 5.0,
    text: "Great experience with G1 Gold Company - offered the best price for my old gold with transparent testing done right in front of me. Quick and smooth process, and I received payment within 30minutes.",
  },
  {
    name: "Vaishnavi Patil",
    location: "Bidar",

    image: REVIEWER_1,
    rating: 4.0,
    text: "Professional and trusted gold buyers in Bangalore. They gave proper attention, checked the gold carefully, and completed the process smoothly with complete transparency throughout.",
  },
  {
    name: "soumya",
    location: "Hubballi",
    initial: "S",
    image: REVIEWER_1,
    rating: 5.0,
    text: "Very professional service. The evaluation process was transparent and I received my payment immediately after confirming the value.",
  },
  {
    name: "Shashidhar Kalamadi",
    location: "Belagavi",
  
    image:  REVIEWER_2,
    rating: 5.0,
    text: "Selling my old jewellery at G1 Gold was very smooth. They explained the purity check and deductions clearly and gave a fair price without confusion and handled everything professionally.",
  },
  {
    name: "Nithya",
    location: "Mysuru",
    initial: "V",
    image: REVIEWER_1,
    rating: 4.0,
    text: "A trustworthy place to sell gold for instant cash. The valuation process was clear, and there were no hidden deductions. Overall, very satisfied with their honest service experience.",
  },
  {
    name: "Basavaraj Pawar",
    location: "Raichur",
   
    image:  REVIEWER_2,
    rating: 5.0,
    text: "One of the best gold buyers I have visited. Gold checking was done properly, valuation was accurate and the payment was given instantly. Service was also quick and smooth.",
  },
   
  ];

function Testimonials() {
  const location = useLocation();
  const scrollingTestimonials = [...testimonials, ...testimonials];

  const normalizedPath = location.pathname.toLowerCase().replace(/\/$/, "");

  const showMalleshwaramMap =
    normalizedPath.includes("sell-gold") &&
    normalizedPath.includes("malleshwaram");

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-50 via-white to-[#fff7df] py-16">
      <style>
        {`
          @keyframes testimonialScroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          .testimonial-track {
            animation: testimonialScroll 32s linear infinite;
          }

          .testimonial-track:hover {
            animation-play-state: paused;
          }
        `}
      </style>


      <div className="mx-auto max-w-[1600px] px-6 lg:px-14">
        <div className="mb-12 text-center">
          <p className="inline-flex rounded-full bg-[#fff1c2] px-4 py-2 text-[11px] font-bold uppercase tracking-[0.22em] text-[#b68b22]">
            Customer Stories
          </p>

          <h2 className="mt-4 text-3xl font-bold text-[#14213d] md:text-4xl lg:text-[44px]">
            What Our Customers Say
          </h2>

          <p className="mx-auto mt-4 max-w-3xl text-base leading-8 text-gray-600">
            Real experiences from customers who trusted G1 Gold for transparent
            gold services.
          </p>
        </div>

        <div className="relative">
          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-16 bg-gradient-to-r from-gray-50 to-transparent md:w-28" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-16 bg-gradient-to-l from-[#fff7df] to-transparent md:w-28" />

          <div className="overflow-hidden">
            <div className="testimonial-track flex w-max gap-6">
              {scrollingTestimonials.map((t, i) => (
                <div
                  key={i}
                  className="w-[310px] shrink-0 rounded-[30px] border border-[#f1e7c8] bg-white p-7 shadow-[0_18px_45px_rgba(20,33,61,0.08)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(20,33,61,0.14)] sm:w-[380px]"
                >
                  <div className="mb-6 flex items-center justify-between gap-4">
                    <div className="font-serif text-6xl leading-none text-[#d4a437]">
                      “
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-1">
                        {[1, 2, 3, 4, 5].map((star, index) => {
                          const fillPercent = Math.max(
                            0,
                            Math.min(100, (t.rating - index) * 100)
                          );

                          return (
                            <svg
                              key={star}
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                            >
                              <defs>
                                <linearGradient id={`star-fill-${i}-${index}`}>
                                  <stop
                                    offset={`${fillPercent}%`}
                                    stopColor="#D4A437"
                                  />
                                  <stop
                                    offset={`${fillPercent}%`}
                                    stopColor="#D1D5DB"
                                  />
                                </linearGradient>
                              </defs>

                              <path
                                fill={`url(#star-fill-${i}-${index})`}
                                d="M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z"
                              />
                            </svg>
                          );
                        })}
                      </div>

                      <span className="text-sm font-bold text-[#14213d]">
                        {t.rating.toFixed(1)}
                      </span>
                    </div>
                  </div>

                  <p className="min-h-[120px] text-[15px] italic leading-7 text-gray-700">
                    {t.text}
                  </p>

                  <div className="mt-7 flex items-center gap-4 border-t border-[#f1e7c8] pt-5">
                    <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full border-2 border-[#f1e7c8] shadow-md">
                      {t.image ? (
                        <img
                          src={t.image}
                          alt={t.name}
                          className="h-full w-full object-cover"
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                            e.currentTarget.parentElement.innerHTML = `<div style="height:100%;width:100%;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#C89B2B 0%,#F2D36A 100%);color:white;font-weight:700;font-size:16px;">${t.initial}</div>`;
                          }}
                        />
                      ) : (
                        <div
                          className="flex h-full w-full items-center justify-center text-base font-bold text-white"
                          style={goldGradient}
                        >
                          {t.initial}
                        </div>
                      )}
                    </div>

                    <div className="min-w-0">
                      <div className="truncate text-base font-bold text-[#14213d]">
                        {t.name}
                      </div>
                      <div className="truncate text-sm text-gray-500">
                        {t.location}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <p className="mt-6 text-center text-xs font-medium text-gray-500 md:hidden">
            Swipe or wait to view more customer stories
          </p>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;